import { UoReportType } from '@/DTOS/UoReport/UoReport';

export type UoPeriodMode = 'date' | 'month' | 'quarter' | 'none';

export interface UoWordParagraph {
  type: 'paragraph';
  id?: string;
  text: string;
  variant?: 'title' | 'subtitle' | 'section' | 'note' | 'body';
  source?: 'template' | 'user' | string;
  style?: UoWordBlockStyle;
}

export interface UoWordSpacer {
  type: 'spacer';
  id?: string;
  source?: 'template' | 'user' | string;
  style?: UoWordBlockStyle;
}

export interface UoWordTableCellStyle {
  textAlign?: 'left' | 'center' | 'right' | 'justify' | string;
  verticalAlign?: 'top' | 'center' | 'bottom' | string;
  background?: string;
  width?: string;
  bold?: boolean;
  italic?: boolean;
  fontSize?: number;
}

export interface UoWordTableCell {
  id: string;
  text: string;
  rowSpan?: number;
  colSpan?: number;
  editor?: 'text' | 'signature' | string;
  signatureRole?: 'technician' | 'beneficiary' | string;
  signatureValue?: string;
  lockedLabel?: string;
  style?: UoWordTableCellStyle;
}

export interface UoWordTableRow {
  cells: UoWordTableCell[];
}

export interface UoWordTable {
  type: 'table';
  id?: string;
  rows: UoWordTableRow[];
  source?: 'template' | 'user' | string;
  style?: UoWordBlockStyle;
}

// Dimensiunile sunt in puncte tipografice, citite din sabloanele Word.
export interface UoWordBlockStyle {
  textAlign?: 'left' | 'center' | 'right' | 'justify' | string;
  fontSize?: number;
  bold?: boolean;
  italic?: boolean;
  spacingBefore?: number;
  spacingAfter?: number;
  pageBreak?: boolean;
  cellPaddingX?: number;
  cellPaddingY?: number;
  rowHeight?: number;
}

export type UoWordBlock = UoWordParagraph | UoWordSpacer | UoWordTable;

export interface UoDocumentTemplate {
  key: UoReportType;
  label: string;
  shortLabel: string;
  group: 'anexe' | 'tehnic';
  templateFile: string;
  deadline: string;
  periodMode: UoPeriodMode;
  blocks: UoWordBlock[];
}

const template = (
  key: UoReportType,
  label: string,
  shortLabel: string,
  group: UoDocumentTemplate['group'],
  templateFile: string,
  deadline: string,
  periodMode: UoPeriodMode,
): UoDocumentTemplate => ({
  key,
  label,
  shortLabel,
  group,
  templateFile,
  deadline,
  periodMode,
  blocks: [],
});

export const UO_DOCUMENT_TEMPLATES: UoDocumentTemplate[] = [
  template('visit', 'Anexa 1 - Registru de vizite la locatia rack-ului', 'Anexa 1', 'anexe', 'Anexa_1_Registru_Vizite.docx', 'Completare obligatorie la fiecare vizita', 'date'),
  template('monthly', 'Anexa 2 - Raport lunar de activitate', 'Anexa 2', 'anexe', 'Anexa_2_Raport_Lunar.docx', 'Max. 5 zile lucratoare dupa incheierea lunii', 'month'),
  template('physicalInspection', 'Anexa 3 - Raport inspectie fizica lunara', 'Anexa 3', 'anexe', 'Anexa_3_Inspectie_Fizica.docx', 'Max. 3 zile lucratoare de la inspectie', 'date'),
  template('upsTest', 'Anexa 4 - Test trimestrial UPS si schema alimentare', 'Anexa 4', 'anexe', 'Anexa_4_Test_UPS_Schema_Alimentare.docx', 'Trimestrial', 'quarter'),
  template('configuration', 'Anexa 5 - Persoane autorizate si contacte', 'Anexa 5', 'anexe', 'Anexa_5_Persoane_Autorizate.docx', 'La predare si la fiecare modificare', 'none'),
];

export const UO_TEMPLATE_BY_KEY = UO_DOCUMENT_TEMPLATES.reduce(
  (acc, template) => {
    acc[template.key] = template;
    return acc;
  },
  {} as Record<UoReportType, UoDocumentTemplate>,
);

export const cloneWordBlocks = (blocks: UoWordBlock[] = []): UoWordBlock[] => JSON.parse(JSON.stringify(blocks));
